/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Media_Progress_CompletedInputs */

const en_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const fr_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const de_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollendet`)
};

const it_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completato`)
};

const ru_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершенный`)
};

const es_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminado`)
};

const zh_cn2_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全的`)
};

const ja_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const hi_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुरा होना।`)
};

const pt_pt2_team_project_import_media_progress_completed = /** @type {(inputs: Team_Project_Import_Media_Progress_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Team_Project_Import_Media_Progress_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_media_progress_completed = /** @type {((inputs?: Team_Project_Import_Media_Progress_CompletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Media_Progress_CompletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_media_progress_completed(inputs)
	if (locale === "de") return de_team_project_import_media_progress_completed(inputs)
	if (locale === "it") return it_team_project_import_media_progress_completed(inputs)
	if (locale === "ru") return ru_team_project_import_media_progress_completed(inputs)
	if (locale === "es") return es_team_project_import_media_progress_completed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_media_progress_completed(inputs)
	if (locale === "ja") return ja_team_project_import_media_progress_completed(inputs)
	if (locale === "hi") return hi_team_project_import_media_progress_completed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_media_progress_completed(inputs)
	return en_team_project_import_media_progress_completed(inputs)
});